import React from 'react';
import SearchBook from '../../components/SearchBook/SearchBook';
import RecNewsComponent from '../../components/RecNewsComponent/RecNewsComponent';

function SearchBookPage() {
  return (
    <>
      <SearchBook />
      <RecNewsComponent />
    </>
  );
}

export default SearchBookPage;
